import React from "react";

import Layout from "../components/layout";
import styled from "styled-components";
import ArticleCard from "../components/articleCard";
import Breadcrumb from "../components/breadcrumb";
import Button from "../components/button";
import ItemCarousel from "../components/itemCarousel";
import MerchantCarousel from "../components/otherMerchantCarousel";
import Tile from "../components/tile";
import Faq from "../components/faq";

const TextContainer = styled.div`
    color:#000;
    margin-top:5%;
    
    @media only screen and (max-width: 694px){
        margin-top:3rem;
    }
`;

const Category = (props) => {
    const { data } = props.pageContext;
    const {intro, customerTitle, customerProduct, product, productTitle, productDescription, merchantPartner, merchantPartnerDes, button, faq, merchantCarousel} = data;

    var content = [];
    content.push(<br/>)
    content.push(
        <Breadcrumb data={intro}/>
    );
    content.push(
        <ArticleCard data={intro} />
    );
    content.push(
        <>
            <TextContainer><h2>{customerTitle}</h2></TextContainer>
            <ItemCarousel data={customerProduct} />
            
            <TextContainer><h2>{productTitle}</h2></TextContainer>
            <p>{productDescription}</p>
            <Tile data={product} />
            
            <br/>
            <TextContainer><h2>{merchantPartner}</h2></TextContainer>
            <p>{merchantPartnerDes}</p>
            <Button data={button} />
        </>
    );
    content.push(
        <>
            <TextContainer><h2>Frequently Asked Questions</h2></TextContainer>
            <Faq data={faq}/>
            <br/><br/>
            <h2>Check our other Merchant</h2>
            <MerchantCarousel data={merchantCarousel} />
        </>
    );

    return <Layout pageData={data}>{content}</Layout>;
};

export default Category;
